module.exports = __webpack_public_path__ + "static/salon-pasajeros---acabado-lateral-1b00b97009281887386ee9e0098ddc33.jpg";